import React, { useContext, useMemo, useRef, useState } from 'react';
import AppContext from '../../Context/AppContext';
import SelectFinishSection from '../Step2/SelectGoals/SelectFinishSection';
const MOCK_FS = [
    { areaId: 1, name: 'Fitness', color: '#15C285' },
    { areaId: 2, name: 'Finance', color: '#ABD86D' },
    { areaId: 3, name: 'Family', color: '#FBBF53' },
    { areaId: 4, name: 'Faith', color: '#F26636' },
    { areaId: 5, name: 'Field', color: '#EC0F47' },
    { areaId: 6, name: 'Friends', color: '#700460' },
    { areaId: 7, name: 'Fun', color: '#022B7A' },
];

const MOCK_ALL_STATE = {
    Fs: MOCK_FS,
    CurrentStep2: 7,
    SelectedOolaOne: {
        areaId: 1,
        text: 'Build a 3-month emergency fund',
        selectedOne: true,
    },
    SelectedGoalsSeven: MOCK_FS.map((f, areaId) => ({
        areaId,
        text:
            areaId === 1
                ? 'Build a 3-month emergency fund'
                : `${f.name}: lead with purpose this season`,
        selectedOne: areaId === 1,
        selected: true,
    })),
};

/**
 * Dev-only public preview for V1 Step 2 completion screen (no login).
 */
const DevStep2FinishPreview = () => {
    const parentCtx = useContext(AppContext);
    const mockSessionRef = useRef({
        firstName: 'Christian',
        token: 'dev-preview',
    });
    const [mobile] = useState(() =>
        typeof window !== 'undefined' ? window.innerWidth <= 768 : false
    );

    const ctx = useMemo(
        () => ({
            ...parentCtx,
            checkUserSession: () => mockSessionRef.current,
        }),
        // Dev preview shell only — keep Provider value stable so finish confetti timer is not reset.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
    if (process.env.NODE_ENV === 'production') {
        return (
            <p style={{ padding: 24 }}>
                This preview is only available in local development.
            </p>
        );
    }

    return (
        <AppContext.Provider value={ctx}>
            <div className="devStep2FinishPreview">
                <SelectFinishSection
                    AllState={MOCK_ALL_STATE}
                    mobile={mobile}
                    handleChangeindexStep={() => {}}
                    portalV2={false}
                />
            </div>
        </AppContext.Provider>
    );
};

export default DevStep2FinishPreview;
